import styled, { css, keyframes } from "styled-components";

const playUnpressAnim = keyframes`
  0%{
    transform: scale(.8)
    transition-timing-function: cubic-bezier(0,0,.2,.93);
    box-shadow: 0 0 0 0 rgba(50, 7, 91, 0.5);

   }
  50%{
    transition-timing-function: cubic-bezier(.31,-0.17,.67,1.21);
    transform: scale(1.05);

   }
  100%{
    box-shadow: 0 15px 10px 0 rgba(50, 7, 91, 0.5);

    transform: scale(1);
   } 
`;
const playUnPress = css`
  ${playUnpressAnim} 0.2s 1 forwards
`;
export const Betbutton = styled.div`
  display: grid;
  grid-template-columns: 20% 60% 20%;
  width: 79.69%;
  max-width: 255px;
  height: 56px;
  border-radius: 38px;
  box-shadow: 0 15px 10px 0 rgba(50, 7, 91, 0.5);
  background-color: #ffb000;
  animation: ${(p) => (p.playUnpress ? playUnPress : null)};
  pointer-events: ${(p) => (p.playPress ? "none" : "auto")};
  ${(p) =>
    p.playPress
      ? "transform: scale(0.8);transition-timing-function: cubic-bezier(.29,.16,.29,1.23); transition: transform 0.1s;"
      : "transform: scale(1); transition-timing-function: cubic-bezier(0.1, 0, 0, 1); transition: transform 0.1s;"};
  /* transition: all 0.3s; */
  /* transform: scale(1) perspective(0) rotateY(0); */
  /* &&.minusOperation {
    transform: perspective(400px) rotateY(-9deg) !important;
    transition: all 0.3s;
  }
  &&.plusOperation {
    transform: perspective(400px) rotateY(9deg) !important;
    transition: all 0.3s;
  }
  &&.playOperation {
    box-shadow: none !important;
    transition: all 0.3s;
    transform: scale(0.95) !important;
  } */
`;
export const FMiddle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  color: #ff3920;
  cursor: pointer;
  p {
    display: flex;
    justify-content: center;
    width: 100%;
    align-items: center;
    font-size: 20px;
    line-height: 1;
  }
  span {
    font-size: 12px;
    white-space: nowrap;
    svg {
      margin-bottom: -1px;
      path {
        fill: #ff3920;
      }
    }
  }
`;
export const Operation = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  & > div {
    ${(p) =>
      p.plusPress || p.minusPress
        ? "transform: scale(0.65); transition-timing-function: cubic-bezier(0.33, 1, 0, 0); transition: transform 0.33s;"
        : "transform: scale(1); transition-timing-function: cubic-bezier(0.1, 0, 0, 1); transition: transform 0.33s;"}
  }

  /* svg {
    pointer-events: none;
  } */
`;
export const Plus = styled.div`
  width: 28px;
  height: 3px;
  background: #fff2de;
  border-radius: 4px;

  ::after {
    content: "";
    position: absolute;
    width: 28px;
    height: 3px;
    background: #fff2de;
    border-radius: 4px;
    transform: rotate(90deg);
  }
`;
export const Minus = styled.div`
  position: absolute;
  width: 28px;
  height: 3px;
  background: #fff2de;
  border-radius: 4px;
  left: 50%;
  margin-left: -9px;
  top: 50%;
  margin-top: -2px;
  transform: ${(p) =>
    p.showOptions ? "scaleX(0.5) rotate(-20deg)" : "scaleX(1) rotate(0)"};
  transform-origin: left;
  transition: transform 250ms;
  ::after {
    content: "";
    position: absolute;
    left: 0px;
    width: 28px;
    height: 3px;
    background: #fff2de;
    border-radius: 4px;
    transform: ${(p) => (p.showOptions ? "rotate(40deg)" : "rotate(0)")};
    transform-origin: left;
  }
`;

// const playPressAnim = keyframes`
//   0%{
//     transition-timing-function: cubic-bezier(0,0,.2,.93);
//     transform: scale(1);
//     box-shadow: 0 15px 10px 0 rgba(50, 7, 91, 0.5);

//    }
//   50%{
//     transition-timing-function: cubic-bezier(.31,-0.17,.67,1.21);
//     transform: scale(.78);

//    }
//   100%{
//     box-shadow: 0 0 0 0 rgba(50, 7, 91, 0.5);
//     transform: scale(0.8)
//    }
// `;
// const playPress = css`
//   ${playPressAnim} 0.5s 1 forwards
// `;
